import * as React from 'react';
import {InputGroup} from 'react-bootstrap';
import {HuePicker, SketchPicker} from 'react-color';
import Form from 'react-bootstrap/Form';
import hexToRgba from 'hex-to-rgba';

export default class HueColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showColorPicker: false};
  }

  render() {
    return (
      <>
        <InputGroup
          onClick={() =>
            this.setState({showColorPicker: !this.state.showColorPicker})
          }
        >
          <InputGroup.Prepend>
            <InputGroup.Prepend>
              <InputGroup.Text
                style={{
                  color: this.hslToHex(this.props.color, 100, 50),
                  backgroundColor: this.hslToHex(this.props.color, 100, 50),
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </InputGroup.Text>
            </InputGroup.Prepend>
          </InputGroup.Prepend>
          <Form.Control readOnly value={this.props.color} />
        </InputGroup>

        {this.state.showColorPicker && (
          <HuePicker
            onClose={() => this.setState({showColorPicker: false})}
            color={this.hslToHex(this.props.color, 100, 50)}
            onChangeComplete={(color) => {
              this.props.onChangeComplete(Math.ceil(color.hsl.h));
              // if (this.props.disableOpacity) {
              //     this.props.onChangeComplete(color.hex);
              // } else {
              //     if (color.rgb.a === 0) {
              //         this.props.onChangeComplete("#00000000")
              //     } else {
              //
              //         this.props.onChangeComplete(color.hex + Math.floor(color.rgb.a * 255).toString(16))
              //     }
              //
              // }
            }}
            onChange={(color) => {
              this.props.onChangeComplete(Math.ceil(color.hsl.h));
              // if (this.props.disableOpacity) {
              //     this.props.onChangeComplete(color.hex);
              // } else {
              //     if (color.rgb.a === 0) {
              //         this.props.onChangeComplete("#00000000")
              //     } else {
              //
              //         this.props.onChangeComplete(color.hex + Math.floor(color.rgb.a * 255).toString(16))
              //     }
              //
              // }
            }}
          />
        )}
      </>
    );
  }

  hslToHex = (h, s, l) => {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  };
}
